module.exports = __webpack_public_path__ + "static/media/js-code.8b3dc465.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/js-code.jpg
// module id = 931
// module chunks = 0